export default __webpack_public_path__ + "static/alarmed-624d33d1f30f90a7ad02cbf75e9fd0b6.svg";